import { createAction } from 'redux-actions'

export const SET_LOGIN_SETTINGS = 'SET_LOGIN_SETTINGS'
export const setLoginSettings = createAction(SET_LOGIN_SETTINGS)

export const SET_PARTNERS_SETTINGS = 'SET_PARTNERS_SETTINGS'
export const setPartnersSettings = createAction(SET_PARTNERS_SETTINGS)

export const SET_SOURCES_SETTINGS = 'SET_SOURCES_SETTINGS'
export const setSourcesSettings = createAction(SET_SOURCES_SETTINGS)

export const SET_DESTINATIONS_SETTINGS = 'SET_DESTINATIONS_SETTINGS'
export const setDestinationsSettings = createAction(SET_DESTINATIONS_SETTINGS)

export const SET_ENABLE_SETTINGS = 'SET_ENABLE_SETTINGS'
export const setEnableSettings = createAction(SET_ENABLE_SETTINGS)

export const SET_SOURCE_INTEGRATIONS_SETTINGS =
  'SET_SOURCE_INTEGRATIONS_SETTINGS'
export const setSourceIntegrationsSettings = createAction(
  SET_SOURCE_INTEGRATIONS_SETTINGS
)

export const SET_SOURCE_SETTINGS_SETTINGS = 'SET_SOURCE_SETTINGS_SETTINGS'
export const setSourceSettingsSettings = createAction(
  SET_SOURCE_SETTINGS_SETTINGS
)

export const SET_SOURCE_SCHEMA_SETTINGS = 'SET_SOURCE_SCHEMA_SETTINGS'
export const setSourceSchemaSettings = createAction(SET_SOURCE_SCHEMA_SETTINGS)

export const SET_SOURCES_LIST_SETTINGS = 'SET_SOURCES_LIST_SETTINGS'
export const setSourcesListSettings = createAction(SET_SOURCES_LIST_SETTINGS)

export const SET_APP_SETTINGS = 'SET_APP_SETTINGS'
export const setAppSettings = createAction(SET_APP_SETTINGS)
